import { useIntl } from 'react-intl'
import CarHireSearchBar from '../CarHireSearchBar/CarHireSearchBar'
import GlobalSearchContainerPane, { GlobalSearchContainerPaneContent } from 'components/Search/GlobalSearch/GlobalSearchContainerPane'
import GlobalSearchHeroContainer from 'components/Search/GlobalSearch/GlobalSearchHeroContainer'
import CarHireMobileSearchControls from '../CarHireMobileSearchControls/CarHireMobileSearchControls'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import RecentCarHireSearches from '../RecentCarHireSearches/RecentCarHireSearches'
import useRecentCarHireSearches from 'hooks/CarHire/useRecentCarHireSearches'

function CarHirePageHeader() {
  const intl = useIntl()
  const recentSearches = useRecentCarHireSearches()

  const title = intl.formatMessage({
    id: 'ucrx2oWNJfhHEpZ5L0m0',
    defaultMessage: 'Car Hire',
    description: 'Page title for the car hire landing page in car hire section',
  })

  return (
    <GlobalSearchHeroContainer
      heroImageId="fbuik31c2rvjvo7mtk2p"
      title={title}
    >
      <GlobalSearchContainerPane displayMobile>
        <GlobalSearchContainerPaneContent>
          <CSSBreakpoint min="tablet">
            <CarHireSearchBar />
          </CSSBreakpoint>
          <CSSBreakpoint max="mobile">
            <CarHireMobileSearchControls />
          </CSSBreakpoint>
          {recentSearches.length > 0 && <RecentCarHireSearches recentSearches={recentSearches} />}
        </GlobalSearchContainerPaneContent>
      </GlobalSearchContainerPane>

    </GlobalSearchHeroContainer>
  )
}

export default CarHirePageHeader
